export default __webpack_public_path__ + "static/newLogoOrange-23c2b037e728b3f7969cf013b9de0182.png";